import './index.css'
import {useMediaQuery} from '@material-ui/core'
import { ReactComponent as  Info} from '../../assets/info.svg'
 
const Footer = () => {
	const matches = useMediaQuery('(min-width:600px)')
  	return (
    	<div className="footer">
			<div style={{paddingBottom:'1.5rem'}}><Info/></div>
	 		<div className="text">
	    		<span className="span">KEKS POS</span> je web aplikacija koja omogućuje svim izdavateljima računa da putem mobilnog telefona generiraju KEKS QR kod te na taj način omoguće svojim korisnicima plaćanje KEKS Pay aplikacijom.
	 		</div>
	 		<a href={'//www.kekspay.hr'} className="link" target="_blank">
	 			Želiš svoj korisnički račun? Saznaj više na webu.
	 		</a>
    	</div>
  )
}

export default Footer
